// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DhEO","newExpiryDate":"styles_newExpiryDate__1yWuD","footer":"styles_footer__-X2wG"};